export default __webpack_public_path__ + "static/media/sleepmaker.da524342.mp4";